<top-banner variant="small"></top-banner>

<div class="main-content">
  <div class="row animated fadeIn">
    <div class="col-md-12">
      <div class="card">
        <div class="card-body mb-2">
          <card-section-header title="Inductions and Training Courses" icon="fas fa-list"></card-section-header>

          <div *ngIf="isLoading" class="temporary-information-message">
            <div class="small-spinner mb-4">
              <p-progressSpinner [strokeWidth]="5"></p-progressSpinner>
            </div>
            <div>
              <p class="mb-0">Loading your training courses</p>
            </div>
          </div>

          <div class="row">
            <div class="col-md-12">
              <div class="filter-flex-row">
                <div>
                  <label>Course or Site Name or Site Owner</label>
                  <text-filter-box (onFilterTextChanged)="onFilterTextChanged($event)"></text-filter-box>
                </div>
              </div>
            </div>
          </div>

          <ng-container *ngIf="!isLoading">
            <div class="row">
              <div class="col-md-12">

                <div *ngIf="!filteredTrainingRows.length" class="empty-panel-state mt-4">
                  <p class="empty-panel-state__message">{{ emptyCoursesMessage }}</p>
                </div>


                <!-- DEKSTOP VIEW -->

                <div class="d-none d-lg-block">
                  <p-table *ngIf="filteredTrainingRows.length" [value]="visiblePageTrainingRows" [responsive]="true" [autoLayout]="true">
                    <ng-template pTemplate="header">
                      <tr>
                        <th class="table-cell-centered"></th>
                        <th>Name</th>
                        <th>Status</th>
                        <th>Expiry</th>
                        <th>Site Operator</th>
                        <th>Required By</th>
                        <th>Sites</th>
                        <th class="table-cell-centered">Actions</th>
                        <th class="table-cell-centered"></th>
                      </tr>
                    </ng-template>

                    <ng-template pTemplate="body" let-row>
                      <tr>
                        <td class="table-cell-centered">
                          <i
                            class="fas fa-check-circle success"
                            *ngIf="row.statusIcon === 'success'"
                          ></i>
                          <i
                            class="fas fa-times-circle danger"
                            *ngIf="row.statusIcon === 'danger'"
                          ></i>
                        </td>

                        <td>
                          <div class="font-weight-bold">{{ row.trainingName }}</div>
                        </td>

                        <td>
                          <div class="mb-1">
                            <span class="badge badge-pill" [ngClass]="row.statusBadgeClass">
                              {{ row.statusLabel }}
                            </span>
                          </div>
                        </td>

                        <td>
                          <div *ngIf="row.expiryPrefix && row.expiryDate">
                            {{ row.expiryPrefix }} {{ row.expiryDate | date: 'yyyy-MM-dd' }}
                          </div>
                        </td>

                        <td>
                          {{ row.siteOwnerName }}
                        </td>

                        <td>
                          <ng-container *ngIf="row.trainingType === TrainingType.Induction; else trainingRequiredBy">
                            {{ row.requiredSiteCount }} {{ 'site' | plural: row.requiredSiteCount }}
                          </ng-container>
                          <ng-template #trainingRequiredBy>
                            <span class="text-muted">Training course</span>
                          </ng-template>
                        </td>

                        <td>
                          <ng-container *ngIf="row.trainingType === TrainingType.Induction && row.requiredSites.length">
                            {{ row.requiredSites.join(', ') }}
                          </ng-container>
                        </td>

                        <td class="table-cell-centered">
                          <div *ngIf="row.action" class="d-flex align-items-center justify-content-center">
                            <ng-container [ngSwitch]="row.action.style">
                              <ng-container *ngSwitchCase="'secondary'">
                                <button
                                  type="button"
                                  class="btn btn-primary btn-link"
                                  (click)="onRowAction(row)"
                                  [disabled]="isSubmitting"
                                >
                                  {{ row.action.label }}
                                </button>
                              </ng-container>
                              <ng-container *ngSwitchDefault>
                                <button
                                  type="button"
                                  class="btn btn-success btn-round"
                                  (click)="onRowAction(row)"
                                  [disabled]="isSubmitting"
                                >
                                  {{ row.action.label }}
                                </button>
                              </ng-container>
                            </ng-container>
                          </div>
                        </td>

                        <td class="table-cell-centered">
                          <div class="d-flex align-items-center justify-content-center">
                            <button
                              type="button"
                              class="btn btn-link text-danger p-0"
                              *ngIf="row.deletableCourse"
                              (click)="onDeleteRow(row)"
                              title="Discard progress"
                              aria-label="Discard progress"
                              [disabled]="isSubmitting"
                            >
                              <i class="fas fa-trash-alt mr-1"></i>
                              Discard progress
                            </button>
                          </div>
                        </td>
                      </tr>
                    </ng-template>
                  </p-table>
                </div>

                <!-- MOBILE VIEW -->

                <div class="d-lg-none">
                  <div *ngFor="let row of visiblePageTrainingRows" class="border-bottom py-3">
                    <button
                      type="button"
                      class="btn btn-link text-left p-0 w-100"
                      (click)="toggleMobileExpansion(row)"
                      [attr.aria-expanded]="isMobileExpanded(row)"
                    >
                      <div class="d-flex align-items-start">
                        <div class="mr-3 pt-1">
                          <i
                            class="fas fa-check-circle success"
                            *ngIf="row.statusIcon === 'success'"
                          ></i>
                          <i
                            class="fas fa-times-circle danger"
                            *ngIf="row.statusIcon === 'danger'"
                          ></i>
                        </div>

                        <div class="flex-fill">
                          <div class="font-weight-bold text-dark">{{ row.trainingName }}</div>
                          <div class="mt-2">
                            <span class="badge badge-pill" [ngClass]="row.statusBadgeClass">
                              {{ row.statusLabel }}
                            </span>
                          </div>
                        </div>

                        <div class="ml-3 pt-1 text-muted">
                          <i class="fas" [ngClass]="isMobileExpanded(row) ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
                        </div>
                      </div>
                    </button>

                    <div *ngIf="isMobileExpanded(row)" class="mt-3 animated fadeIn">
                      <div class="mb-2">
                        <div class="small-data text-muted">Site Operator</div>
                        <div>{{ row.siteOwnerName }}</div>
                      </div>

                      <div class="mb-2">
                        <div class="small-data text-muted">Required By</div>
                        <div *ngIf="row.trainingType === TrainingType.Induction; else mobileTrainingRequiredBy">
                          {{ row.requiredSiteCount }} {{ 'site' | plural: row.requiredSiteCount }}
                        </div>
                        <ng-template #mobileTrainingRequiredBy>
                          <div>Training course</div>
                        </ng-template>
                      </div>

                      <div class="mb-2" *ngIf="row.trainingType === TrainingType.Induction && row.requiredSites.length">
                        <div class="small-data text-muted">Sites</div>
                        <div>{{ row.requiredSites.join(', ') }}</div>
                      </div>

                      <div class="border-top pt-3 mt-3">
                        <div class="mb-3" *ngIf="row.expiryPrefix && row.expiryDate">
                          <div class="small-data text-muted">Expiry</div>
                          <div>{{ row.expiryPrefix }} {{ row.expiryDate | date: 'yyyy-MM-dd' }}</div>
                        </div>

                        <div class="d-flex align-items-center justify-content-between">
                          <div>
                            <button
                            type="button"
                            class="btn btn-link text-danger p-0"
                            *ngIf="row.deletableCourse"
                            (click)="onDeleteRow(row)"
                            title="Discard progress"
                            aria-label="Discard progress"
                            [disabled]="isSubmitting"
                          >
                            <i class="fas fa-trash-alt mr-1"></i>
                            Discard progress
                          </button>
                        </div>

                          <div *ngIf="row.action">
                            <ng-container [ngSwitch]="row.action.style">
                              <ng-container *ngSwitchCase="'secondary'">
                                <button
                                  type="button"
                                  class="btn btn-primary btn-link"
                                  (click)="onRowAction(row)"
                                  [disabled]="isSubmitting"
                                >
                                  {{ row.action.label }}
                                </button>
                              </ng-container>
                              <ng-container *ngSwitchDefault>
                                <button
                                  type="button"
                                  class="btn btn-success btn-round"
                                  (click)="onRowAction(row)"
                                  [disabled]="isSubmitting"
                                >
                                  {{ row.action.label }}
                                </button>
                              </ng-container>
                            </ng-container>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </ng-container>
        </div>
        <div class="card-footer">
          <ng-container *ngIf="!isLoading">
            <p-paginator
              #paginator
              [alwaysShow]="true"
              [rows]="pagination.size"
              [totalRecords]="pagination.totalRecords"
              [rowsPerPageOptions]="pageSizes"
              (onPageChange)="paginate($event)">
            </p-paginator>
          </ng-container>
        </div>
      </div>
    </div>
  </div>
</div>
